import {
  GridRowColumn,
  makeGridConfig,
} from '@/componentsV1/BaseComponents/Grid'
import TextArea, { TextAreaProps } from '@/componentsV1/BaseComponents/TextArea'

const CommentArea = (props: TextAreaProps) => (
  <GridRowColumn {...makeGridConfig([8, 14], true)}>
    <TextArea {...props} />
  </GridRowColumn>
)

export default CommentArea
